import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type SizeSettingSetResponse, SizeSettings } from '@air/api';
import { callAirApi } from '@air/utils-api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getPrivateSizeSetsListKey } from '../usePrivateSizeSetsList';

export type UsePrivateSizeSetsCreateMutationParams = NonNullable<Parameters<typeof SizeSettings.Sets.create>[0]>;

export const usePrivateSizeSetsCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UsePrivateSizeSetsCreateMutationParams) => {
      return callAirApi<SizeSettingSetResponse>(() => SizeSettings.Sets.create(params));
    },

    onError: (error, variables) => {
      reportErrorToBugsnag({
        context: 'Failed to create size set',
        error,
        metadata: {
          data: variables,
          key: 'data',
        },
      });
    },

    onSettled: async (_data, _error, variables) => {
      await queryClient.invalidateQueries({
        queryKey: getPrivateSizeSetsListKey({ workspaceId: variables.workspaceId }),
      });
    },
  });
};
